// extracted by mini-css-extract-plugin
export default {"notFoundComponent":"notFoundComponent__sCwev","inner":"inner__Phs7G","titleContainer":"titleContainer__yPJ_4","title":"title__flg6A","button":"button__Odj1e"};